import router from '@/router'

//进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
NProgress.configure({ showSpinner: false }) // 进度条配置不显示右上角环形加载

const white_list = ['/login'] // 没有重定向的白名单

router.beforeEach((to, from, next) => {
  NProgress.start()
  const token = sessionStorage.getItem('userNmae')
  if (token) {
    // 如果有token的情况还挑登录页，则重定向回主页
    to.path === '/login' && next({ path: '/' })
    // 结束进度条
    NProgress.done()
  } else {
    if (white_list.indexOf(to.path) !== -1) {
      // 配置白名单的直接通过
      next()
      // 结束进度条
      NProgress.done()
    } else {
      next(`/login?redirect=${to.path}`)
      // 结束进度条
      NProgress.done()
    }
  }
  next()
})

router.afterEach(() => {
  // 结束进度条
  NProgress.done()
})
